import React from 'react';
import classNames from 'classnames';
import { T } from '@sm/intl';
import useSurveyStyles from './useStyles';

const DEFAULT_COPY = {
  TEXT: {
    id: 'ExitLink.Text',
    defaultMessage: 'Exit',
    description: '[Type: Link][Vis: med] - Exit link label',
  },
};

function getLinkDetails(
  label?: React.ReactNode,
  defaultLabel?: React.ReactNode
): { label?: React.ReactNode; translate?: 'yes' | 'no' } {
  return { label: label ?? defaultLabel, translate: label ? 'no' : undefined };
}

export type Props = { href: string; text?: string } & React.AllHTMLAttributes<HTMLAnchorElement>;

function ExitLink({ href, text, className, ...anchorProps }: Props): React.ReactElement {
  const { exitLink } = useSurveyStyles();
  const link = getLinkDetails(text, <T desc={DEFAULT_COPY.TEXT} />);
  return (
    <a
      href={href}
      translate={link.translate}
      className={classNames(exitLink, className)}
      data-testid="ExitLink__Link"
      {...anchorProps}
    >
      {link.label}
    </a>
  );
}

export default ExitLink;
